import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useResponsive } from '../../contexts/ResponsiveContext';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { GetResponsiveWidth } from './TabsComponent';

interface ReactiveBannerProps {
    title: string;
    description: string;
    bannerImage: string;
}

const ReactiveBanner: FunctionComponent<ReactiveBannerProps> = ({
    title,
    description,
    bannerImage,
}) => {
    const { isScreenXs } = useResponsive();

    const bannerStyle = {
        display: 'flex',
        flexDirection: 'column' as 'column',
        backgroundImage: `linear-gradient(rgba(183, 83, 50, 0.8), rgba(183, 83, 50, 0.8)), url(${bannerImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '100%',
        color: 'white',
    };

    return (
        <div style={bannerStyle}>
            <Box
                sx={{
                    width: GetResponsiveWidth,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    margin: 'auto',
                    minHeight: '180px',
                }}
            >
                <h1
                    style={{
                        ...styles.bannerFont,
                        fontSize: isScreenXs ? '26px' : styles.bannerFont.fontSize,
                        marginBottom: isScreenXs ? '6px' : styles.bannerFont.marginBottom,
                        marginTop: '1rem',
                    }}
                >
                    {title}
                </h1>
                <span
                    style={{
                        ...styles.bannerFont2,
                        fontSize: isScreenXs ? '14px' : styles.bannerFont2.fontSize,
                        marginBottom: '1rem',
                    }}
                >
                    {description}
                </span>
            </Box>
        </div>
    );
};

export default ReactiveBanner;
